export function createPageUrl(pageName: string) {
    const [path, query] = pageName.split('?');
    const base = '/' + path.toLowerCase().replace(/ /g, '-');
    return query ? base + '?' + query : base;
}
